import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalDialogComponent } from '@vg-constellation/angular-19/modal-dialog';

@Component({
  selector: 'app-preview-message',
  templateUrl: './preview-message.component.html',
  styleUrl: './preview-message.component.scss',
  standalone: false,
})
export class PreviewMessageComponent {
  // ============================================
  // ViewChild
  // ============================================
  @ViewChild('messagePreview', { static: false }) messagePreview!: ModalDialogComponent;

  // ============================================
  // Inputs
  // ============================================

  /**
   * Header text to display in preview
   */
  @Input() header = '';

  /**
   * Message text (can be single line or multi-line with \n)
   */
  @Input() messageTextLines: string[] = [];

  /**
   * Custom heading for the modal
   * @default 'Preview message text'
   */
  @Input() headingText = 'Preview message text';

  // ============================================
  // Outputs
  // ============================================

  /**
   * Emitted when modal is closed
   */
  @Output() closeEvent = new EventEmitter<void>();


  // ============================================
  // Public Methods
  // ============================================
  openModal(): void {
    this.messagePreview.openModalDialog();
  }

  /**
   * Close the modal
   */
  closeModal(): void {
    this.messagePreview?.closeDialogModal();
  }

  /**
   * Handle modal close event
   */
  onClosePreviewMessage(): void {
    this.closeModal();
  }
}
